import { convertObject } from "./convertObject";
/**
 * Converts enum to a dictionary object, with keys the keys of the enum and value a TOutput
 */
export const convertEnumToDic = (en, cb) => convertObject(en, cb);
